const PAIR_SYMBOL_TO_PAIR_ADDRESS = {
  WETH_USDT: "0x06da0fd433c1a5d7a4faa01111c044910a184553",
  DAI_WETH: "0xc3d03e4f041fd4cd388c549ee2a29a9e5075882f"
};

const PAIR_ADDRESS_TO_REWARDS_POOL = {
  [PAIR_SYMBOL_TO_PAIR_ADDRESS.WETH_USDT]: 0,
  [PAIR_SYMBOL_TO_PAIR_ADDRESS.DAI_WETH]: 2,
};

const POOL_ID_TO_REWARDS_ADDRESSES = {
  [PAIR_ADDRESS_TO_REWARDS_POOL[PAIR_SYMBOL_TO_PAIR_ADDRESS.WETH_USDT]]: ["0x6b3595068778dd592e39a122f4f5a5cf09c90fe2"],
  [PAIR_ADDRESS_TO_REWARDS_POOL[PAIR_SYMBOL_TO_PAIR_ADDRESS.DAI_WETH]]: ["0x6b3595068778dd592e39a122f4f5a5cf09c90fe2"],
};

const PAIR_ADDRESS_TO_REWARDS_LENGTH = {
  [PAIR_SYMBOL_TO_PAIR_ADDRESS.WETH_USDT]: 1,
};

module.exports = {
  ADDRESS: "0xc2edad668740f1aa35e4d8f227fb8e17dca888cd",
  PAIR_SYMBOL_TO_PAIR_ADDRESS,
  POOL_ID_TO_REWARDS_ADDRESSES,
  PAIR_ADDRESS_TO_REWARDS_POOL,
  PAIR_ADDRESS_TO_REWARDS_LENGTH
};
